var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "verify-content" },
    [
      !_vm.translationsLoaded
        ? _c("div", [_c("circle-loader")], 1)
        : _c("div", [
            _c(
              "div",
              { staticClass: "account-page ctsform" },
              [
                _c("v-container", { attrs: { fluid: "" } }, [
                  _c("h2", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Account.SequentialVerification.ChangeDetail.Title." +
                              _vm.page
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.PersonalDetails.ChangeDetail.Subtitle." +
                            _vm.page
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("form", { attrs: { id: "confirmEmalByPinForm" } }, [
                  _vm.page === "verify_email"
                    ? _c(
                        "div",
                        {
                          staticClass: "control-block",
                          class: { filled: _vm.email }
                        },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(_vm._s(_vm.verifyDetail))
                          ]),
                          _vm._v(" "),
                          _vm.page === "verify_email"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.email,
                                    expression: "email",
                                    modifiers: { trim: true }
                                  }
                                ],
                                attrs: {
                                  type: "email",
                                  maxlength: "255",
                                  autocomplete: "off",
                                  id: "email"
                                },
                                domProps: { value: _vm.email },
                                on: {
                                  focusout: function($event) {
                                    !_vm.changeDetails.PrimaryEmail
                                      ? (_vm.errorMessages.email = true)
                                      : (_vm.errorMessages.email = false)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value.trim()
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "control-block",
                          class: { filled: _vm.phone }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.phone,
                                expression: "phone",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "tel",
                              maxlength:
                                _vm.validationRules &&
                                _vm.validationRules.phoneLength,
                              autocomplete: "off",
                              id: "phone"
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              focusout: function($event) {
                                !_vm.changeDetails.MobilePhone
                                  ? (_vm.errorMessages.phone = true)
                                  : (_vm.errorMessages.phone = false)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phone = $event.target.value.trim()
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(_vm._s(_vm.verifyDetail))
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.page === "verify_mob"
                    ? _c("div", [
                        _vm.errorMessages.phone
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_missing" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.Phone")
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.phoneNonDigit
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_not_digit" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.PhoneNonDigit")
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.phoneLength
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_phone_length" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.PhoneLength", {
                                    length:
                                      _vm.validationRules &&
                                      _vm.validationRules.phoneLength
                                  })
                                )
                              }
                            })
                          : _vm._e()
                      ])
                    : _c("div", [
                        _vm.errorMessages.email
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_email_missing" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.Email")
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.emailValid
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              attrs: { id: "err_msg_email_invalid" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("Account.Join.ErrorMsg.EmailInvalid")
                                )
                              }
                            })
                          : _vm._e()
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            type: "submit",
                            "x-large": ""
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.updateDetails()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.SequentialVerification.ChangeDetail.Update." +
                                    _vm.page
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn changeBtn",
                          attrs: { "x-large": "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goBack(_vm.wrongDetail.channel)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.SequentialVerification.ChangeDetail.ReturnFromEnteredWrongData.GoBack"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Text"
            ),
            successTitle: _vm.$t(
              "Account.PersonalDetails.Dialog.Success.Title"
            ),
            successText: _vm.$t("Account.PersonalDetails.Dialog.Success.Text"),
            errorTitle: _vm.$t("Account.PersonalDetails.Dialog.Error.Title"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _c(
              "p",
              { staticClass: "generic-icon-note" },
              [
                _c(
                  "v-icon",
                  { staticClass: "mr-1", attrs: { color: "error" } },
                  [_vm._v("error")]
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Account.PersonalDetails.Dialog.Error.Text"))
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "response-error" }, [
              _vm._v(_vm._s(_vm.transactionError))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.PersonalDetails.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-424d765a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424d765a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/ChangeDetail.vue
// module id = null
// module chunks = 